export default theme => ({
  root:{
    '& > *': {
      borderBottom: 'unset',
    }
  },
  lastTableCell: {
    paddingRight: theme.spacing(0),
  },
  buttonRight: {
    float: 'right',
    paddingRight: theme.spacing(1)
  },
  largeTableCell: {
    paddingBottom: 0,
    paddingTop: 0,
    paddingRight: theme.spacing(0.5),
    paddingLeft: theme.spacing(0.5)
  },
  dangerColor: {
    color: theme.palette.danger.main
  },
  error: {
    color: theme.palette.danger.main
  },
  ok: {
    color: theme.palette.success.main
  },
  statusDisplay: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center'
  }
});
